import { useEffect, useMemo, useState } from "react";
import images from "../../../assets/images/constantImages";
import { useDispatch, useSelector } from "react-redux";
import { getItemsDetails } from "./ItemsSlice";
import { formatRupees } from "../../Common/ApiCommon/ApiService";
import icons from "../../../assets/images/constantIcons";
import DeleteItems from "./DeleteItems";
import EditItemsForms from "./EditItemsForms";

const useAddItems = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const dispatch = useDispatch();
  const [editPopupIndex, setEditPopupIndex] = useState(null);
  const [deletePopupIndex, setDeletePopupIndex] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const { items = [], loading } = useSelector((state) => ({
    items: state.items.items,
    loading: state.items.loading,
  }));

  useEffect(() => {
    dispatch(getItemsDetails());
  }, [dispatch]);

  const handleDeleteItem = (id) => {
    setDeletePopupIndex(id);
  };
  const handleEditItems = (id) => {
    const item = items.find((item) => item.id === id);
    setSelectedItem(item);
    setEditPopupIndex(id);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Item ID",
        accessor: "id",
        headerAlign: "text-left",
        cellAlign: "text-left",
        Cell: ({ value }) => <div className="text-nowrap">{value}</div>,
      },
      {
        Header: "Categories",
        accessor: "canteen_category_name",
        headerAlign: "text-left",
        cellAlign: "text-left",
        // Cell: ({ value }) => <div className="w-[200px] bg-red">{value}</div>,
      },
      {
        Header: "Items",
        accessor: "name",
        headerAlign: "text-left",
        cellAlign: "text-left",
        Cell: ({ row }) => {
          const imageUrl = row.original.image
            ? `https://headquater.pixoatic.com${row.original.image}`
            : images.defaultprofilepicture;

          return (
            <div className="flex items-center justify-start lg:justify-center gap-2">
              <img
                src={imageUrl}
                alt={row.original.name}
                className="w-8 h-8 object-cover rounded-full"
              />
              <span>{row.original.name}</span>
            </div>
          );
        },
      },
      {
        Header: "price",
        accessor: "price",
        Cell: ({ value }) => (
          <div className="text-nowrap">{formatRupees(value)}</div>
        ),
      },
      {
        Header: "Meal type",
        accessor: "meal_type",
        Cell: ({ value }) => <div className="text-nowrap">{value}</div>,
      },
      {
        Header: "Action",
        accessor: "action",
        headerAlign: "text-left",
        cellAlign: "text-center",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <div className="flex justify-start lg:justify-center gap-5">
              <button
                onClick={() => handleEditItems(row.original.id)}
                className="p-2 flex items-center justify-center focus:outline-none w-[40px] h-[40px] rounded-full bg-green50 text-green cursor-pointer"
              >
                <icons.FaRegEdit className="text-xl font-bold" />
              </button>

              <button
                onClick={() => handleDeleteItem(row.original.id)}
                className="p-2 flex items-center justify-center focus:outline-none w-[40px] h-[40px] rounded-full bg-red bg-opacity-15 text-red cursor-pointer"
              >
                <icons.AiOutlineDelete className="text-xl font-bold" />
              </button>
              {deletePopupIndex === row.original.id && (
                <DeleteItems
                  isOpen={deletePopupIndex === row.original.id}
                  onClose={() => handleDeleteItem(null)}
                  itemId={row.original.id}
                />
              )}

              {editPopupIndex === row.original.id && (
                <EditItemsForms
                  isOpen={true}
                  onClose={() => {
                    setEditPopupIndex(null);
                    setSelectedItem(null);
                  }}
                  itemData={selectedItem}
                />
              )}
            </div>
          );
        },
      },
    ],
    [deletePopupIndex, editPopupIndex]
  );

  const data = items || [];

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  return {
    columns,
    currentRows,
    totalRows: data.length,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    loading,
  };
};

export default useAddItems;
